import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createTheme } from '../../../theme';

const withTheme = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const theme = createTheme({
    colorPreset: 'blue',
    contrast: 'normal',
    direction: 'ltr',
    paletteMode: 'light',
    responsiveFontSizes: true,
  });
  // Toasts are rendered by the single <Toaster /> mounted in app.jsx;
  // mounting another one here duplicates every visible toast
  const WithThemeProvider: React.FC<P> = (props) => (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WrappedComponent {...(props as P)} />
    </ThemeProvider>
  );
  return WithThemeProvider;
};

export default withTheme;
